import { useRouter } from '@fabric-app/compat';
import { SIGNIN_POST_LOGIN_REDIRECT_QUERY_PARAM } from '../auth.config.js';
import { isString, isObject } from '@fabric-app/utils/guards';
import { useState, useCallback } from 'react';
import { generatePath } from '@fabric-app/utils/url/routing';
import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';
import { appRoutes } from '../../app/routing/routes.config.js';
import { parseUrlSafe } from '../../expandedResource/expandedResource.utils.js';

const usePostSigninRedirect = () => {
  const { push } = useRouter();
  const [postSigninRedirect, setPostSigninRedirect] = useState(null);
  const getPostSigninRedirect = useCallback(() => {
    const redirect = sessionStorage.getItem(SIGNIN_POST_LOGIN_REDIRECT_QUERY_PARAM);
    if (!redirect) return null;
    const { url, persistedQueryParams } = JSON.parse(redirect);
    if (!isString(url)) return null;
    return {
      url,
      persistedQueryParams: isObject(persistedQueryParams) ? persistedQueryParams : void 0
    };
  }, []);
  useClientLayoutEffect(() => {
    const redirect = getPostSigninRedirect();
    if (!redirect) return;
    setPostSigninRedirect(redirect);
  }, [
    getPostSigninRedirect
  ]);
  return {
    postSigninRedirect,
    redirectToSignin: useCallback(({ redirectUrl, persistedQueryParams } = {}) => {
      const url = parseUrlSafe(redirectUrl ?? "") ?? new URL(window.location.href);
      const path = url.pathname + url.search;
      if (!path) return;
      sessionStorage.setItem(SIGNIN_POST_LOGIN_REDIRECT_QUERY_PARAM, JSON.stringify({
        url: path,
        persistedQueryParams
      }));
      setPostSigninRedirect({
        url: path,
        persistedQueryParams
      });
      push(generatePath(appRoutes.auth.signin, {}));
    }, [
      push
    ]),
    clearPostSigninRedirect: useCallback(() => {
      sessionStorage.removeItem(SIGNIN_POST_LOGIN_REDIRECT_QUERY_PARAM);
    }, [])
  };
};

export { usePostSigninRedirect };
//# sourceMappingURL=usePostSigninRedirect.js.map
